import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownSchoolAttendanceOfficers = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, school_id } ) =>
{
    const addDesi = (recs) =>
    {
        // Add the desi teacher option to allow un-selection of the attendance officer
        return [ ... recs, { value: -1, label: 'Designated Teacher'} ] ;
    }

    const fields = { url: '/schools/' + school_id + '/attendanceofficers', keyFieldName: 'user_id', labelFieldName: 'name', postProcessingFn :addDesi};

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownSchoolAttendanceOfficers;
